import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-hilfe',
  templateUrl: './hilfe.page.html',
  styleUrls: ['./hilfe.page.scss'],
})
export class HilfePage implements OnInit {
  
  @Input() site: string;

  constructor(public modalController: ModalController) { }

  ngOnInit() {
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
